<div class="component-container flex flex-col gap-[40px]">
  <app-change-orders-request-filters class="filters-section mt-[40px]" />
  <app-change-orders-request-list class="list-section" />
</div>
